// src/store.js
import { configureStore } from "@reduxjs/toolkit";
import searchPaginationReducer from "./slice/searchPaginationSlice";

export const store = configureStore({
  reducer: {
    searchPagination: searchPaginationReducer,
  },
});
